import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import staging from './staging';
import resetpassword from './resetpassword';
import emailvalidation from './emailvalidation';

import {
    REFRESH_TOKEN_REQUEST,
    REFRESH_TOKEN_SUCCESS,
    REFRESH_TOKEN_FAILURE
} from './refresh/constants';
import {
    SUCCESS_PASSWORD_RESET_COMMIT,
    SUCCESS_PASSWORD_RESET_INIT
} from './resetpassword/constants';
import { NAME } from './constants';
import { REQUEST_LOGIN, SUCCESS_LOGIN, FAILURE_LOGIN } from './login/constants';
import { REQUEST_LOGOUT, SUCCESS_LOGOUT, FAILURE_LOGOUT } from './logout/constants';
import { REQUEST_REGISTER, SUCCESS_REGISTER, FAILURE_REGISTER } from './register/constants';

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_LOGOUT:
        case REQUEST_LOGIN:
        case REQUEST_REGISTER:
        case REFRESH_TOKEN_REQUEST:
            return true;
        case SUCCESS_REGISTER:
        case SUCCESS_LOGIN:
        case SUCCESS_LOGOUT:
        case REFRESH_TOKEN_SUCCESS:
        case FAILURE_REGISTER:
        case FAILURE_LOGIN:
        case FAILURE_LOGOUT:
        case REFRESH_TOKEN_FAILURE:
            return false;
        default:
            return state;
    }
};

const token = (state = '', action) => {
    switch (action.type) {
        case SUCCESS_REGISTER:
        case SUCCESS_LOGIN:
        case REFRESH_TOKEN_SUCCESS:
            return action.response.payload.token;
        case SUCCESS_LOGOUT:
        case FAILURE_REGISTER:
        case FAILURE_LOGIN:
        case FAILURE_LOGOUT:
        case REFRESH_TOKEN_FAILURE:
            return '';
        default:
            return state;
    }
};

const isAuthenticated = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_REGISTER:
        case SUCCESS_LOGIN:
        case REFRESH_TOKEN_SUCCESS:
            return true;
        case SUCCESS_PASSWORD_RESET_COMMIT:
        case SUCCESS_PASSWORD_RESET_INIT:
        case SUCCESS_LOGOUT:
        case FAILURE_REGISTER:
        case FAILURE_LOGIN:
        case FAILURE_LOGOUT:
        case REFRESH_TOKEN_FAILURE:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_REGISTER:
        case FAILURE_LOGIN:
        case FAILURE_LOGOUT:
        case REFRESH_TOKEN_FAILURE:
            return action.response.message;
        case SUCCESS_LOGIN:
        case SUCCESS_LOGOUT:
        case SUCCESS_REGISTER:
        case REFRESH_TOKEN_SUCCESS:
        case REQUEST_LOGIN:
        case REQUEST_LOGOUT:
        case REQUEST_REGISTER:
        case REFRESH_TOKEN_REQUEST:
            return '';
        default:
            return state;
    }
};

const code = (state = null, action) => {
    switch (action.type) {
        case FAILURE_REGISTER:
        case FAILURE_LOGIN:
        case FAILURE_LOGOUT:
        case REFRESH_TOKEN_FAILURE:
        case SUCCESS_LOGIN:
        case SUCCESS_REGISTER:
        case REFRESH_TOKEN_SUCCESS:
            return action.response.status;
        case SUCCESS_LOGOUT:
        case REQUEST_LOGIN:
        case REQUEST_LOGOUT:
        case REQUEST_REGISTER:
        case REFRESH_TOKEN_REQUEST:
            return null;
        default:
            return state;
    }
};

// Persist only token
const authenticationPersistConfig = {
    key: NAME,
    storage: storage,
    whitelist: ['token', 'isAuthenticated']
};

const reducer = combineReducers({
    fetching,
    isAuthenticated,
    token,
    error,
    code,
    [resetpassword.constants.NAME]: resetpassword.reducer,
    [staging.constants.NAME]: staging.reducer,
    [emailvalidation.constants.NAME]: emailvalidation.reducer
});

export default persistReducer(authenticationPersistConfig, reducer);



// WEBPACK FOOTER //
// ./src/services/authentication/reducer.js